import React, { useState, useCallback, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import IdentityMigrationCompletedModalContents from './IdentityMigrationCompletedModalContents';
import { useStore } from '~/src/hooks/useMst';

const IdentityMigrationCompletedModalContainer = () => {
  const history = useHistory();
  const location = useLocation();
  const store = useStore();
  const { user } = store;
  const userEmail = user?.currentOrganization?.email || '';

  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const state = urlParams.get('state');

    if (state === 'completed_identity_migration') {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }, [location.search]);

  const handleClose = useCallback(() => {
    const urlParams = new URLSearchParams(location.search);
    urlParams.delete('state');
    const newSearch = urlParams.toString();
    history.replace({
      pathname: location.pathname,
      search: newSearch ? `?${newSearch}` : '',
    });
    setIsOpen(false);
  }, [history, location.pathname, location.search]);

  return (
    <IdentityMigrationCompletedModalContents
      open={isOpen}
      onClose={handleClose}
      email={userEmail}
    />
  );
};

export default IdentityMigrationCompletedModalContainer;
